import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../../services/common.service';
import {User} from '../../../../models/user';

@Component({
  selector: 'app-auth-step-validation',
  templateUrl: './auth-step-validation.component.html',
  styleUrls: ['./auth-step-validation.component.scss']
})
export class AuthStepValidationComponent implements OnInit {
  secretCode = '';
  user: User;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private commonService: CommonService,
              public dialogRef: MatDialogRef<AuthStepValidationComponent>) {
    this.user = data.user;
  }

  ngOnInit(): void {

  }

}
